"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _map = _interopRequireDefault(require("lodash/map"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
} // ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Imports
// ----------------------------------------------------------------------------
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Libraries
// ----------------------------------------------------------------------------
// ------------------------------------------------------------------- Function
// ----------------------------------------------------------------------------

/** decreaseCountOfObjectInShoppingCart */


var decreaseCountOfObjectInShoppingCart = function decreaseCountOfObjectInShoppingCart(defaultState, previousState, payload) {
  var thatTotalPriceOfObjects = previousState.shoppingCartState.totalPriceOfObjects;
  var thisCountsOfObjects = previousState.shoppingCartState.objectsCounts;
  var thisTotalCountOfObjects = previousState.shoppingCartState.totalCountOfObjects;

  if (thisCountsOfObjects[payload] > 0) {
    thisCountsOfObjects[payload] -= 1;
    thisTotalCountOfObjects = previousState.shoppingCartState.totalCountOfObjects - 1;
  }

  var thisTotalPrice = [];
  (0, _map["default"])(previousState.shoppingCartState.objectsList, function (object) {
    thisTotalPrice.push(object.price * thisCountsOfObjects[object.routeSlug]);
  });
  var thisTotalPriceOfObjects = thisTotalPrice.reduce(function (a, b) {
    return a + b;
  }, 0);
  return Object.assign({}, previousState, {
    shoppingCartState: {
      objectsList: previousState.shoppingCartState.objectsList,
      objectsCounts: thisCountsOfObjects,
      totalCountOfObjects: thisTotalCountOfObjects,
      totalPriceOfObjects: thisTotalPriceOfObjects,
      thatTotalPriceOfObjects: thatTotalPriceOfObjects,
      thisTotalPriceOfObjects: thisTotalPriceOfObjects
    }
  });
}; // ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Exports
// ----------------------------------------------------------------------------


var _default = decreaseCountOfObjectInShoppingCart;
exports["default"] = _default;
module.exports = exports.default;